import styled from 'styled-components';

export const CellContent = styled.div.attrs<{ className?: string }>({ className: 'table-cell-content' })`
  margin: 0;
  display: flex;
  align-items: center;

  .rates {
    .rate {
      padding: 5px 0 0;
      font-size: 10px;
      font-style: normal;
      font-weight: 400;
      line-height: 100%; /* 10px */
    }
  }
`;
